import UserCompanyRelationshipModel from '../models/UserCompanyRelationshipModel';
import IService from './IService';
import Axios from 'axios';

export default class UserCompanyRelationshipClasservice implements IService<UserCompanyRelationshipModel> {

    constructor() {
    }

    async list(filter: any) {
        const data = [];
        var res = await Axios.post('/api/UserCompanyRelationship/list', filter);
        if (res.data.success) {
            return res.data.data.map((itm: any) => {
                let ret = new UserCompanyRelationshipModel();
                ret.idNRelacionEmpresaUsuario = itm.idNRelacionEmpresaUsuario;
                ret.fkNEmpresa = itm.fkNEmpresa;
                ret.fkNUsuario = itm.fkNUsuario;

                return ret;
            });
        }
        return null;
    }

    async insert(data: UserCompanyRelationshipModel) {
        var res = await Axios.post('/api/UserCompanyRelationship/insert', data);
        return res.data;
    }

    async update(data: UserCompanyRelationshipModel) {
        var res = await Axios.put('/api/UserCompanyRelationship/update', data);
        return res.data;
    }

    async delete(data: UserCompanyRelationshipModel) {
        var res = await Axios.delete('/api/UserCompanyRelationship/delete?id=' + data.idNRelacionEmpresaUsuario);
        return res.data;
    }

    async export(filter: any) {
        var res = await Axios.post('/api/UserCompanyRelationship/export', filter, {
            responseType: 'blob'
        });
        return res.data;
    }

    async getByUser(user: number) {
        var res = await Axios.get('/api/UserCompanyRelationship/getbyuser?user=' + user);
        return res.data;
    }

    async get(id: number) {
        var res = await Axios.get('/api/UserCompanyRelationship/get', {
            params: {
                id: id
            }
        });
        if (res.data.success) {
            return res.data;
        }
        return null;
    }

}